import {BimElement} from 'app/shared/model/bim-element';
import {TypeElement} from 'app/shared/model/type-element';
import {ParentElement} from 'app/shared/model/parent-element';

export class BimElementUtils {

    /**
     * Renvoie l'id de l'élément s'il est du type passé en paramètre, ou l'id du parent de ce type.
     */
    static getSelfOrParentId(element: BimElement, type: TypeElement): string {
        if (!element) {
            return null;
        }
        if (element.typeElement == type) {
            return element.id;
        }
        return this.getParentId(element.parents, type);
    }

    /**
     * Renvoie l'id parent du type passé en paramètre.
     */
    static getParentId(parents: ParentElement[], type: TypeElement): string {
        if (!parents) {
            return null;
        }
        const parent = parents.find(it => it.type == type);
        return parent ? parent.id : null;
    }

}
